import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RebatesRoutingModule } from './rebates-routing.module';
import { RebatesPage } from './rebates.page';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RebatesRoutingModule,
    SharedModule,
    FormsModule,
    TranslateModule,
  ],
  declarations: [RebatesPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RebatesModule {}
